import React from 'react';
import { Note, type NoteProps } from './NotePrimitives';

export const ErrorNote = ({
  size,
  className,
  children,
}: React.PropsWithChildren<Pick<NoteProps, 'size' | 'className'>>) => (
  <Note variant="error" size={size} className={className}>
    {children}
  </Note>
);
